import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import {
  PROTOTYPE_VIEWER_API_REF,
  PrototypeViewerClient,
} from './api/PrototypeViewerApi';
import { rootRouteRef } from './routes';

export const prototypeViewerPlugin = createPlugin({
  id: 'prototype-viewer',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: PROTOTYPE_VIEWER_API_REF,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new PrototypeViewerClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const PrototypeViewerPage = prototypeViewerPlugin.provide(
  createRoutableExtension({
    name: 'PrototypeViewerPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
